import { Link } from "gatsby"
import React from "react"
import logo from "../assets/images/OCC_logo.png"

const copy = {
  en: {
    about: "About",
    our_story: "Our Story",
    how_it_works: "How It Works",
    faq: "FAQ",
    donate_now: "Donate Now",
    contact_us: "Contact Us",

    more_info: "More Information",
    find_church: "Find A Church",
    register: "Register",
    sign_in: "Sign In",
    announcements: "Announcements",

    feature_sites: "Feature Sites",
    welcome_church: "Welcome Church",
    refugee: "Refugee",
    intl_student_coming: "International Student (coming)",

    initiative_of: "An Initiative Of",
    occ_all_caps: "OUR COMMON CALLING",

    copyright_prefix: "Copyright ©",
    powered_by: "Powered by",
    powered_by_name: "Kingdomdev",
  },

  cn: {
    about: "關於",
    our_story: "我們的故事",
    how_it_works: "運作方式",
    faq: "常見問題",
    donate_now: "奉獻",
    contact_us: "聯絡我們",

    more_info: "更多資訊",
    find_church: "尋找教會",
    register: "註冊",
    sign_in: "登入",
    announcements: "公告",

    feature_sites: "精選網站",
    welcome_church: "Welcome Church",
    refugee: "難民",
    intl_student_coming: "國際學生（即將推出）",

    initiative_of: "所屬計劃",
    occ_all_caps: "OUR COMMON CALLING",

    copyright_prefix: "版權所有 ©",
    powered_by: "技術支援",
    powered_by_name: "Kingdomdev",
  },
}

const Footer = ({ lang = "en" }) => {
  const t = key => copy[lang][key] || key
  const isChinese = lang === "cn"

  return (
    <footer>
      <section className="footer__link_section">
        <div className="footer__link_category">
          <p>
            <strong>{t("about")}</strong>
          </p>
          <Link to={isChinese ? "/cn/about/" : "/about/"}>
            {t("our_story")}
          </Link>
          <Link to="http://welcomechurch.ca/how-it-works/">
            {t("how_it_works")}
          </Link>
          <Link to={isChinese ? "/cn/faq/" : "/faq/"}>{t("faq")}</Link>
          <Link to={isChinese ? "/cn/donate/" : "/donate/"}>
            {t("donate_now")}
          </Link>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfQcYwJPecpLFheLcvaqO3SqXTaC2ajkzTnIC_A_zYxcsVGlA/viewform"
            target="_blank"
            rel="noreferrer"
          >
            {t("contact_us")}
          </a>
        </div>

        <div className="footer__link_category">
          <p>
            <strong>{t("more_info")}</strong>
          </p>
          <Link to={isChinese ? "/cn/connect/" : "/connect/"}>
            {t("find_church")}
          </Link>
          <Link to="https://www.welcomechurch.ca/register/">
            {t("register")}
          </Link>
          <Link to="https://canwelcomechurches.ca/">{t("sign_in")}</Link>
          <Link to="https://www.welcomechurch.ca/announcements/">
            {t("announcements")}
          </Link>
        </div>

        <div className="footer__link_category">
          <p>
            <strong>{t("feature_sites")}</strong>
          </p>
          <a
            href="https://www.welcomechurch.ca/"
            target="_blank"
            rel="noreferrer"
          >
            {t("welcome_church")}
          </a>
          <a href="https://www.canrefugee.ca/" target="_blank" rel="noreferrer">
            {t("refugee")}
          </a>
          <span>{t("intl_student_coming")}</span>
        </div>

        <p className="footer__our_common_calling">
          {t("initiative_of")}
          <img src={logo} alt="OUR COMMON CALLING logo" />
          {t("occ_all_caps")}
        </p>
      </section>

      <p>
        {t("copyright_prefix")} {new Date().getFullYear()} Our Common Calling.{" "}
        {t("powered_by")} {t("powered_by_name")}
      </p>
    </footer>
  )
}

export default Footer
